module.exports = __webpack_public_path__ + "media/images/placeholders/covid-5a3cc793b8bfcf12b99e2a698b303880.jpg";